import React from "react";
import "antd/dist/antd.css";
import { Result } from "antd";


const ErrorPage = (props) => {
    return (
  <Result subTitle="Sorry, something went wrong." />
  );
};

export default ErrorPage;
